import React from 'react';
import RoundButton from './RoundButton';
import { FiBell } from 'react-icons/fi';
import styled from 'styled-components/macro';
import { useTranslate } from '../../contexts/languageContext';
import { responsive } from '../../resources/constantes.json';
import { useViewContext } from 'contexts/viewContext';


const BellButton = ({ unreadSize = 0, onClick = () => { } },) => {
    const t = useTranslate();
    const esHistorico = useViewContext().esHistorico;
    return (
        <RoundButton style={{ backgroundColor: "#215CCC" }} onClick={onClick} label={t('notificaciones')} disabled={esHistorico}>
            {unreadSize > 0 ? (
                <BellWithNumberContainer>
                    <FiBell style={{ width: '50%', height: '50%' }} />
                    <BellNumber>{unreadSize > 9 ? '9+' : unreadSize}</BellNumber>
                </BellWithNumberContainer>

            ) : (
                <FiBell style={{ width: '50%', height: '50%' }} />
            )}
            <div className="visually-hidden">
                {unreadSize + ' ' + t('notificacionesSinLeer')}
            </div>
        </RoundButton>
    );
};

const BellWithNumberContainer = styled.div`
    position:relative;
    width:100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const BellNumber = styled.div`
    position: absolute;
    top: -4px;
    right: -4px;
    background: #EB2F2F;
    border-radius: 10rem;
    width: 2.4rem;
    height: 2.4rem;
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: ${responsive.maxWidth.mobile}px) {
        width: 1.8rem;
        height: 1.8rem;
        font-size: 1rem;
  }
`


export default BellButton;
